// XNGAGE CONFIDENTIAL
// __________________________
//
// Copyright (C) 2023 Xngage - All Rights Reserved
//
// All code or information contained herein is, and remains the
// property of Xngage LLC and its customers.  The intellectual
// and technical concepts contained are proprietary to Xngage LLC
// and may be covered by U.S. and Foreign Patents, patents in
// process, and are protected by trade secret or copyright law.
// Dissemination of this information or reproduction of this material
// is strictly forbidden unless prior written permission is obtained
// from Xngage LLC.
//

import { addToChainAfter, HandlerWithResult } from "@insite/client-framework/HandlerCreator";
import { chain, SetFilterQuery } from "@insite/client-framework/Store/Pages/ProductList/Handlers/SetFilterQuery";
import { getIsPreviouslyPurchasedPage } from "@werner/App/Store/Selectors/GeneralSelectors";
import qs from "qs";

type HandlerType = HandlerWithResult<{}, string>;

export const XngSetFilterQuery: typeof SetFilterQuery = props => {
    const queryObject = qs.parse(props.result);

    // XNG-Changes: this is to prvent adding previouslyPurchasedProducts to url query string
    if (getIsPreviouslyPurchasedPage(props.getState())) {
        delete queryObject.previouslyPurchasedProducts;
    }

    props.result = qs.stringify(queryObject, { arrayFormat: "comma", skipNulls: true });
};

addToChainAfter(chain, SetFilterQuery, XngSetFilterQuery);
